export class InvalidColorException extends Error {

}
